module.exports = __webpack_public_path__ + "img/home_business_txt.b94fb5e1.png";